import { saveDataQuery } from '@/services/analytics/Action';
import { useDispatch, useSelector } from 'react-redux';

export const useDailyDataQuery = () => {
  const dispatch = useDispatch();
  const dataQuery = useSelector((state) => state.analytics.dataQuery);

  const setQuery = (obj) => {
    dispatch(
      saveDataQuery({
        ...dataQuery,
        esgData: {
          ...dataQuery.esgData,
          dailyData: {
            ...dataQuery.esgData.dailyData,
            ...obj,
          },
        },
      }),
    );
  };

  return [setQuery];
};
